import { get, post } from "./base";

export const updateTermsAndContionals = async (response) => {
  return await get("/Usuario/updatetermsuse?&isTermAccepted=" + response);
};

export const solicitarRestablecerPin = async (correo) => {
    try {
      const request = { correo : correo };
      const response = await post(`/Usuario/Restablecer/Pin`, JSON.stringify(request));
      return response.data;
    } catch (error) {
      throw new Error("Error solicitando restablecer PIN : " + error.message);
    }
  };

  
export const cambiarPin = async (data) => {
    try {
        const response = await post(`/Usuario/Cambiar/Pin`, JSON.stringify(data));
        return response.data;
    } catch (error) {
        throw new Error("Error cambiando PIN : " + error.message);
    }
};